import $ from 'jquery'

$(document).on('turbo:load', function () {

    function jobYear() {
        return $('[name="job[job_date(1i)]"] option:selected').val();
    }

    function paymentType() {
        const instId = $('.admin-paymenttype').find('option:selected').val();
        if (!instId) {
            return
        }
        const shadow = $('.admin-paymenttype-shadow');
        return shadow.find('[value="' + instId + '"]').data('payment-type');
    }

    function switchPaymentTypeByInstitute() {
        if ($('.admin-paymenttype').length == 0) {
            return
        }

        const formerPaymentType = $('.payment-type-container').data('payment-type') || '';
        const selectedPaymentType = paymentType();
        const typesHtml = {
            'default': '<div class="field"><div class="control"><label class="nice-form__label nice-form__label--for-radio">Standard</label><input type="hidden" value="default" name="job[payment_type]" id="job_payment_type"></div></div>',
            'selfpaying': '<div class="field"><div class="control"><label class="nice-form__label nice-form__label--for-radio">Selbstzahler</label><input type="hidden" value="selfpaying" name="job[payment_type]" id="job_payment_type"></div></div>',
            'partly_selfpaying': '<div class="field"><div class="control"><label class="nice-form__label nice-form__label--for-radio"><input class="radio" type="radio" value="default" checked="' + (formerPaymentType == 'default' && 'checked') + '" name="job[payment_type]">Standard</label><label class="nice-form__label nice-form__label--for-radio"><input class="radio" type="radio" value="selfpaying"  checked="' + (formerPaymentType == 'selfpaying' && 'checked') + '" name="job[payment_type]">Selbstzahler</label></div></div>'
        }
        selectedPaymentType in typesHtml && $ptc.html(typesHtml[selectedPaymentType]);

        // toggle travel cost fields
        const variableTravelCostFields = $('[data-variable-travel-cost-field="true"]');
        const fieldsEnabled = selectedPaymentType == 'selfpaying';
        variableTravelCostFields.prop('disabled', !fieldsEnabled);
        //variableTravelCostFields.parent('.nice-form__label').toggleClass('nice-form__label--disabled', !fieldsEnabled);
        variableTravelCostFields.closest('tr').find('.nice-form__label').toggleClass('nice-form__label--disabled', !fieldsEnabled);
    }

    const $ptc = $('.payment-type-container');

    $('.payment-type-container').html('<div class="field"><div class="control"><label class="nice-form__label nice-form__label--for-radio">-</label>');

    switchPaymentTypeByInstitute();


    function switchTravelCostTypeByLanguage() {
        const langId = $('.admin-travelcost').find('option:selected').val();
        let selectedTravelCostValue = 0;

        // if current job date is 2026 and not self paying
        const useReducedTravelcost = jobYear()
            && parseInt(jobYear()) >= 2026
            && paymentType() != 'selfpaying';
        let fieldName = useReducedTravelcost ? 'travelcost-dolpaep' : 'travelcost';

        if (langId) {
            selectedTravelCostValue =
                $('.admin-travelcost-shadow')
                    .find('[value="' + langId + '"]')
                    .data(fieldName);
        }
        $('[name="job[travel_cost]"],[data-travel-cost-field]').val(selectedTravelCostValue);
        if (parseInt(selectedTravelCostValue) > 0) {
            $('input#job_travel_cost_reason_by_language').prop('checked', true);
        } else {
            $('input#job_travel_cost_reason_none').prop('checked', true);
        }
    }

    $('.admin-paymenttype').on('change', switchPaymentTypeByInstitute);
    $('.admin-paymenttype').on('change', switchTravelCostTypeByLanguage);
    $('.admin-travelcost').on('change',  switchTravelCostTypeByLanguage);
    $('.admin-paymenttype').on('change', switchTravelCostTypeByLanguage);
    $('[name="job[job_date(1i)]"]').on('change', switchTravelCostTypeByLanguage);

    return
});
